/**
 * 외주(gtli) 관리자 파리티 조회 API — 차량 관리·세차 차량 기록·세차요금 기록 화면 전용.
 *
 * ⚠️ 미러(modernwashMirror.js, legacy_mw_* 스냅샷)와도, 라이브 어댑터 다른 라우트와도 별개다.
 *   이 API 는 외주 관리자(jj001.gtli.co.kr)를 백엔드가 live read-only 로 조회한 결과(AdapterEnvelope)를 반환한다.
 *   운영 승인(1회 예외)으로 민감 컬럼을 그대로 노출하되, 접근은 백엔드에서 master/연동매장(jeonju) 매니저로 강제.
 *
 * 경로: GET /owner-console/modernwash/vendor-parity/*  (axios baseURL 이 /api/v1 을 붙인다)
 *
 * 스코프: master 는 storeId 를 함께 보낸다. manager 는 보내지 않는다(백엔드가 본인 매장으로 강제).
 * 응답 봉투: { enabled, scope, source:{reachable,degraded,error}, items?, data?, reason? }
 */
import api from './client';

const VENDOR_BASE = '/owner-console/modernwash/vendor-parity';

/** undefined/null/'' 파라미터는 제거(빈 값 400 방지). */
const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''),
  );

/** [A] 회원 구독 차량 목록 — items: VendorVehicleItem[]. */
export async function getVendorVehicleList(params = {}) {
  const res = await api.get(`${VENDOR_BASE}/vehicle-list`, { params: cleanParams(params) });
  return res.data;
}

/** [B] 세차 인식 이벤트(loop_event_time 대표행) — items: VendorWashLogItem[] (images 포함). */
export async function getVendorWashLog(params = {}) {
  const res = await api.get(`${VENDOR_BASE}/wash-log`, { params: cleanParams(params) });
  return res.data;
}

/** [C] 결제 건별 — items: VendorPaymentItem[], data:{ totalPaidfee }. */
export async function getVendorPayments(params = {}) {
  const res = await api.get(`${VENDOR_BASE}/payments`, { params: cleanParams(params) });
  return res.data;
}

/**
 * [B-이미지] LPR 캡처 이미지 — Bearer 게이트를 유지하기 위해 blob 으로 받아 objectURL 로 렌더한다.
 * (공개 <img src> 금지 · 토큰을 쿼리에 넣지 않음). 반환: Blob.
 */
export async function getVendorWashImage(params = {}) {
  const res = await api.get(`${VENDOR_BASE}/wash-image`, {
    params: cleanParams(params),
    responseType: 'blob',
  });
  return res.data;
}
